import React from "react";
import { Typography } from "@mui/material";
import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import AvatarInitials from "components/Header/HeaderSections/AvatarInitials";
import { Calendar, Timer, Clock, Stethoscope, GlobeHemisphereWest } from "@phosphor-icons/react";

const VideoSessionDetails = (props) => {
  const {
    classes,
    startDate,
    endDate,
    totalCallTime,
    serviceType,
    clinicianName,
    parentName,
    clientName,
    otherClinicianName,
    customerDetails,
    timezone,
  } = props;
  let participantsOptions = [clinicianName, clientName, parentName, "Other"];
  if (otherClinicianName) {
    participantsOptions.splice(3, 0, otherClinicianName);
  }
  const clientInitials = clientName
    ? `${clientName.split(" ")[0][0]?.toUpperCase()}${clientName.split(" ")[1][0]?.toUpperCase()}`
    : "";

  return (
    <div className={classes.callDetailRow}>
      <div className={classes.sessionDetailsTitle}>
        <AvatarInitials userInitials={clientInitials} size={32} />
        <Typography component="p" variant="body1" style={{ marginLeft: 12 }}>
          {clientName}
        </Typography>
      </div>
      {startDate && (
        <div className={classes.callDetail}>
          <Calendar size={20} color="rgba(0, 0, 0, 0.56)" />
          <Typography component="p" variant="body2Secondary">
            {format(new Date(startDate), "PPP")}
          </Typography>
        </div>
      )}

      <div className={classes.callDetail}>
        <Clock size={20} color="rgba(0, 0, 0, 0.56)" />
        <Typography component="p" variant="body2Secondary">{`${totalCallTime} minutes`}</Typography>
      </div>

      <div className={classes.callDetail}>
        <Timer size={20} color="rgba(0, 0, 0, 0.56)" />
        <Typography component="p" variant="body2Secondary">
          {(timezone || customerDetails?.timezone) &&
            startDate &&
            endDate &&
            `${formatInTimeZone(new Date(startDate), timezone || customerDetails?.timezone, "h:mm a")} - ${formatInTimeZone(
              new Date(endDate),
              timezone || customerDetails?.timezone,
              "h:mm a zzz"
            )}`}
        </Typography>
      </div>

      <div className={classes.callDetail}>
        <Stethoscope size={20} color="rgba(0, 0, 0, 0.56)" />
        <Typography component="p" variant="body2Secondary">
          {customerDetails?.diagnosis}
        </Typography>
      </div>

      <div className={classes.callDetail}>
        <GlobeHemisphereWest size={20} color="rgba(0, 0, 0, 0.56)" />
        <Typography component="p" variant="body2Secondary">
          {serviceType?.place_of_service || "Telehealth"}
        </Typography>
      </div>
    </div>
  );
};

export default VideoSessionDetails;
